import React, { Component } from 'react';
import './LightBlue1.css';
import { Parallax } from 'react-scroll-parallax';

class LightBlue1 extends Component {
  render() {
    return (
        <div className="whiteBackground">
          <div className="containerBlue">
          <Parallax
                className="custom-class"
                offsetYMax={40 + '%'}
                offsetYMin={0 + '%'}
                slowerScrollRate
                tag="figure"
            >
            <div className="blueBox" />
                      <Parallax
                className="custom-class"
                offsetXMax={0 + '%'}
                offsetXMin={20 + '%'}
                slowerScrollRate
                tag="figure"
            >
            <div className="blueBox2" />
            </Parallax>
            </Parallax>
            <div className="naostro">Teď jedeme<span style={{fontSize: 130 + 'px', fontWeight: 'bold'}}><br></br>naostro!</span></div>
            <div className="zkusenosti"> 
              Pět let zkušeností, pádů a kotrmelců.
              Majáles UTB zdarma byl kvalitní zvukovou
              zkouškou před velkým turné. Nyní jsme
              připraveni jet naostro. Zlín čeká v květnu
              hudební festival, o kterém bude vědět každý.
              Buďte jeho součástí.
            </div>
          </div>
        </div>
    );
  }
}

export default LightBlue1;